import {createSlice} from "@reduxjs/toolkit";
import {getAllNews} from "./action";

const initialState = {
  state: {
    items: []
  },
  loading: true,
  error: ''
} as BaseState<NewsState>

const slice = createSlice({
  name: 'newsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllNews.pending, (state) => ({
          ...state,
          loading: true
        })
    )
    builder.addCase(getAllNews.fulfilled, (state, action) => {
        const { items, meta, summary } = action.payload
        return {
          state: {
            items,
            meta,
            summary,
          },
          loading: false,
          error: null
        }
      }
    )
    builder.addCase(getAllNews.rejected, () => ({
          state: {
            items: [],
            meta: null,
            summary: null,
          },
          loading: false,
          error: 'Failed to get news, please try again'
        })
    )
    
  }
})

export default slice